import { t as g } from "./index-d77fce4f.js";
import { g as S } from "./index-d77fce4f.js";
import { jsx as i } from "react/jsx-runtime";
import * as l from "react";
import { C as D, e as V, P as t, u as T, n as b, T as x, f as E, _ as u, b as y, h as M, i as C, j as v } from "./createTheme-6e68f5ca.js";
import "./common.utils-016769eb.js";
let m;
typeof document == "object" && (m = V({
  key: "css",
  prepend: !0
}));
function N(o) {
  const {
    injectFirst: r,
    children: e
  } = o;
  return r && m ? /* @__PURE__ */ i(D, {
    value: m,
    children: e
  }) : e;
}
process.env.NODE_ENV !== "production" && (N.propTypes = {
  /**
   * Your component tree.
   */
  children: t.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: t.bool
});
function R(o, r) {
  if (typeof r == "function") {
    const e = r(o);
    return process.env.NODE_ENV !== "production" && (e || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), e;
  }
  return u({}, o, r);
}
function d(o) {
  const {
    children: r,
    theme: e
  } = o, n = T();
  process.env.NODE_ENV !== "production" && n === null && typeof e == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const c = l.useMemo(() => {
    const s = n === null ? e : R(n, e);
    return s != null && (s[b] = n !== null), s;
  }, [e, n]);
  return /* @__PURE__ */ i(x.Provider, {
    value: c,
    children: r
  });
}
process.env.NODE_ENV !== "production" && (d.propTypes = {
  /**
   * Your component tree.
   */
  children: t.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: t.oneOfType([t.object, t.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (d.propTypes = E(d.propTypes));
const $ = ["value"], H = /* @__PURE__ */ l.createContext();
function P(o) {
  let {
    value: r
  } = o, e = y(o, $);
  return /* @__PURE__ */ i(H.Provider, u({
    value: r ?? !0
  }, e));
}
process.env.NODE_ENV !== "production" && (P.propTypes = {
  children: t.node,
  value: t.bool
});
const f = {};
function a(o, r, e, n = !1) {
  return l.useMemo(() => {
    const c = o && r[o] || r;
    if (typeof e == "function") {
      const s = e(c), p = o ? u({}, r, {
        [o]: s
      }) : s;
      return n ? () => p : p;
    }
    return o ? u({}, r, {
      [o]: e
    }) : u({}, r, e);
  }, [o, r, e, n]);
}
function h(o) {
  const {
    children: r,
    theme: e,
    themeId: n
  } = o, c = M(f), s = T() || f;
  process.env.NODE_ENV !== "production" && (c === null && typeof e == "function" || n && c && !c[n] && typeof e == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const p = a(n, c, e), _ = a(n, s, e, !0), O = p.direction === "rtl";
  return /* @__PURE__ */ i(d, {
    theme: _,
    children: /* @__PURE__ */ i(C.Provider, {
      value: p,
      children: /* @__PURE__ */ i(P, {
        value: O,
        children: r
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (h.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: t.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: t.oneOfType([t.func, t.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: t.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (h.propTypes = E(h.propTypes));
const Y = ["theme"];
function j(o) {
  let {
    theme: r
  } = o, e = y(o, Y);
  const n = r[v];
  return /* @__PURE__ */ i(h, u({}, e, {
    themeId: n ? v : void 0,
    theme: n || r
  }));
}
process.env.NODE_ENV !== "production" && (j.propTypes = {
  /**
   * Your component tree.
   */
  children: t.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: t.oneOfType([t.object, t.func]).isRequired
});
function w(o) {
  return /* @__PURE__ */ i(N, { injectFirst: !0, children: /* @__PURE__ */ i(j, { theme: g, children: o.children }) });
}
export {
  w as ThemeProvider,
  S as getColor,
  g as theme
};
//# sourceMappingURL=theme.entry.js.map
